/** Parcours ouverts dans le navigateur mobile (liens email, mot de passe, etc.). */
const PWA_GATE_EXEMPT_PREFIXES = [
  '/forgot-password',
  '/reset-password',
  '/complete-signup',
];

export function isPwaInstallGateExemptPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return PWA_GATE_EXEMPT_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
